/**
 * Dark-Theme-Tokens des Optimierungen-Drawers (Claude-Design drawer-v2).
 * Als Tailwind-Klassen-Konstanten gebündelt (Tailwind-only, kein Custom-CSS;
 * DRY + hält die Komponenten unter dem Size-Limit). Farben als Design-System-
 * Tokens (FE-023) — farbgleich zu den vorherigen Hex-Werten aus drawer-v2.css.
 */

export const DV2 = {
  // Flächen
  bg: 'bg-neutral-950',
  card: 'bg-card',
  card2: 'bg-card2',
  // Linien
  line: 'border-white/[0.08]',
  lineStrong: 'border-white/[0.14]',
  // Text
  fg1: 'text-neutral-50',
  fg2: 'text-neutral-300',
  fg3: 'text-neutral-400',
  fg4: 'text-neutral-500',
  // GOKI-Orange (Aktions-Akzent)
  orange: 'text-primary-500',
  orangeBg: 'bg-primary-500',
  // NEU = grün (Diff-Konvention)
  addFg: 'text-green-400',
  addBd: 'border-[rgba(34,197,94,0.28)]',
  addBg: 'bg-[rgba(34,197,94,0.07)]',
  addRail: 'bg-green-500',
  // ALT = rot/gedämpft
  remFg: 'text-red-300',
  remBd: 'border-[rgba(239,68,68,0.18)]',
  remBg: 'bg-[rgba(239,68,68,0.05)]',
  remRail: 'bg-[rgba(239,68,68,0.55)]',
  // Amber-Warnung (rule_compliant=false)
  warnFg: 'text-amber-300',
  warnBd: 'border-[rgba(245,158,11,0.30)]',
  warnBg: 'bg-[rgba(245,158,11,0.10)]',
  // Fehler
  errFg: 'text-red-300',
  errBd: 'border-[rgba(239,68,68,0.30)]',
  errBg: 'bg-[rgba(239,68,68,0.10)]',
} as const

/** Status-Kind einer Feldzeile (steuert Icon/Farbe). */
export type FieldKind = 'err' | 'warn' | 'new' | 'done'
